import { useState } from 'react';

export default function CopyCode({ textToCopy, className = '' }) {
  const [copied, setCopied] = useState(false);

  function handleClick(e) {
    e.stopPropagation();
    navigator.clipboard.writeText(textToCopy);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  }

  return (
    <button
      onClick={handleClick}
      type="button"
      title="Copy referral code"
      className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded bg-black/50 border border-[#ff544a]/30 hover:border-[#ff544a] text-xs font-mono text-[#ff544a] transition-all active:scale-95 cursor-pointer ${className}`}
    >
      <span className="font-bold tracking-widest">{textToCopy}</span>
      {copied ? (
        <span className="material-symbols-outlined text-[14px] text-green-400">check</span>
      ) : (
        <span className="material-symbols-outlined text-[14px] opacity-70 hover:opacity-100">content_copy</span>
      )}
      {copied && <span className="text-[10px] text-green-400 ml-1 uppercase">Copied!</span>}
    </button>
  );
}
